(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["expandable-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('expandable-video')) {
    customElements.define('expandable-video', class extends HTMLElement {
      connectedCallback() {
        if (this.openButton) return;
        this.openButton = this.querySelector('.expandable-video__open');
        this.preview = this.querySelector('video');
        this.openButton.addEventListener('click', () => this.openPlayer());
      }

      disconnectedCallback() {
        this.closePlayer();
      }

      openPlayer() {
        if (this.dialog) return;
        this.resumePreview = !this.preview.paused;
        this.preview.pause();
        this.slideshow = this.closest('slideshow-component');
        this.resumeSlideshow = Boolean(this.slideshow?.autoplayButtonIsSetToPlay);
        if (this.resumeSlideshow) this.slideshow.autoPlayToggle();

        this.dialog = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.reusePlayer = this.hasAttribute('data-reuse-player');
        if (this.reusePlayer) {
          this.previewState = {
            attributes: new Map(['autoplay', 'muted', 'loop', 'controls', 'preload', 'playsinline'].map(
              (name) => [name, this.preview.getAttribute(name)]
            )),
            time: this.preview.currentTime,
            muted: this.preview.muted,
            volume: this.preview.volume,
            rate: this.preview.playbackRate,
          };
          this.previewSlot = document.createElement('span');
          this.previewSlot.hidden = true;
          this.preview.before(this.previewSlot);
          this.player = this.preview;
          if (this.player.readyState > 0) this.player.currentTime = 0;
        } else {
          this.player = this.preview.cloneNode(true);
          this.player.removeAttribute('id');
        }
        this.player.removeAttribute('autoplay');
        this.player.removeAttribute('muted');
        this.player.removeAttribute('loop');
        this.player.controls = true;
        this.player.playsInline = true;
        this.player.muted = false;
        this.player.preload = 'auto';
        this.dialog.append(this.player);
        document.body.append(this.dialog);

        const soundButton = this.dialog.querySelector('.expanded-video__sound');
        const updateSound = () => {
          soundButton.textContent = this.player.muted ? soundButton.dataset.soundOn : soundButton.dataset.soundOff;
        };
        soundButton.addEventListener('click', () => {
          this.player.muted = !this.player.muted;
          updateSound();
        });
        this.playerEvents = new AbortController();
        this.player.addEventListener('volumechange', updateSound, { signal: this.playerEvents.signal });
        updateSound();
        this.dialog.querySelector('.expanded-video__close').addEventListener('click', () => this.closePlayer());
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closePlayer();
        });
        this.dialog.addEventListener('close', () => this.closePlayer());
        document.documentElement.classList.add('expanded-video-open');
        this.dialog.showModal();
        this.player.play().catch(() => {});
      }

      closePlayer() {
        if (!this.dialog) return;
        const dialog = this.dialog;
        this.dialog = null;
        this.playerEvents.abort();
        this.player.pause();
        if (this.reusePlayer) {
          this.previewState.attributes.forEach((value, name) => {
            if (value === null) this.player.removeAttribute(name);
            else this.player.setAttribute(name, value);
          });
          this.player.muted = this.previewState.muted;
          this.player.volume = this.previewState.volume;
          this.player.playbackRate = this.previewState.rate;
          this.previewSlot.replaceWith(this.player);
          if (this.player.readyState > 0) this.player.currentTime = this.previewState.time;
          if (!this.resumePreview) this.player.pause();
        } else {
          this.player.removeAttribute('src');
          this.player.querySelectorAll('source').forEach((source) => source.remove());
          this.player.load();
        }
        dialog.close();
        dialog.remove();
        document.documentElement.classList.remove('expanded-video-open');
        if (this.isConnected) {
          if (this.resumePreview) this.preview.play().catch(() => {});
          this.openButton.focus({ preventScroll: true });
          if (this.resumeSlideshow && this.slideshow.isConnected && !this.slideshow.autoplayButtonIsSetToPlay) {
            this.slideshow.autoPlayToggle();
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
